import { ReactNode } from 'react';
import Image from 'next/image';

import { Box, Flex, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { Markdown } from '~/components/markdown';

export type ScholarshipPageBodySectionProps = {
  footerSlot?: ReactNode;
  title?: string | null;
  text?: string | null;
};

export function ScholarshipPageBodySection({ footerSlot = null, text, title }: ScholarshipPageBodySectionProps) {
  return (
    <Box
      as='section'
      bgGradient='linear(to-b, white, accent.sky.100)'
      display='flex'
      flexDir='column'
      gap={{
        base: '40px',
        md: '64px',
      }}
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      {!!title && !!text && (
        <ContentContainer>
          <Flex
            flexDir={{
              base: 'column',
              md: 'row',
            }}
            gap={{
              base: '40px',
              md: '128px',
            }}
          >
            <Box flex='1 2'>
              <Heading as='h2' marginBottom='24px' size='marketing-4xl'>
                {title}
              </Heading>
              <Markdown markdownText={text} />
            </Box>
            <Box
              position='relative'
              flex={{
                md: '0 1 352px',
              }}
              height={{
                base: '392px',
                md: 'unset',
              }}
            >
              <Image
                alt=''
                sizes='352px'
                src='/images/backgrounds/floating-shapes-2.png'
                style={{
                  objectFit: 'contain',
                }}
                fill
              />
            </Box>
          </Flex>
        </ContentContainer>
      )}
      {footerSlot}
    </Box>
  );
}
